import { render, staticRenderFns } from "./tab9.vue?vue&type=template&id=0d8fae04"
import script from "./tab9.vue?vue&type=script&lang=js"
export * from "./tab9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8fae04')) {
      api.createRecord('0d8fae04', component.options)
    } else {
      api.reload('0d8fae04', component.options)
    }
    module.hot.accept("./tab9.vue?vue&type=template&id=0d8fae04", function () {
      api.rerender('0d8fae04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab9.vue"
export default component.exports